import axios from 'axios';
import { apiUrl } from '../utils/api.js';
import { useState, useRef } from 'react';

const maybeValidPostalCode = value => value.match(/^[0-9]{4}$/);

export function PostalCodeInput({ label, onChange, ref2 }) {
  const [postalCode, setPostalCode] = useState(null);
  const [isInvalidPostalCode, setIsInvalidPostalCode] = useState('');

  const canceller = useRef(() => {});

  async function handleChange(event) {
    canceller.current();

    const value = event.target.value.trim();

    setPostalCode(null);

    if (value === '') {
      setIsInvalidPostalCode(false);

      return;
    }

    if (!maybeValidPostalCode(value)) {
      return;
    }

    axios
      .get(apiUrl(`postal-codes/${value}`), {
        cancelToken: new axios.CancelToken(c => (canceller.current = c)),
      })
      .then(response => {
        setIsInvalidPostalCode(false);

        setPostalCode(response.data);

        onChange(response.data);
      })
      .catch(error => {
        if (error.response && error.response.status === 404) {
          setIsInvalidPostalCode(true);

          return;
        }

        if (!axios.isCancel(error)) {
          throw error;
        }
      });
  }

  return (
    <label className="root">
      <span className="label">{label}</span>
      <div className="inputContainer">
        <input
          className={`input ${isInvalidPostalCode ? 'input--error' : ''}`}
          type="text"
          placeholder="0000"
          inputMode="numeric"
          pattern="[0-9]*"
          onChange={handleChange}
          ref={ref2}
        />
        <span className="inputCity">{postalCode ? postalCode.city : ''}</span>
      </div>
      <style jsx>{`
        .root {
          position: relative;
          display: block;
        }

        .label {
          display: block;
          margin-bottom: 9px;
          font-weight: 600;
          color: var(--bgBlueish__text);
        }

        .input {
          width: 100%;
          box-sizing: border-box;
          height: 50px;
          padding: 0 12px;
          margin-bottom: 18px;
          background-color: var(--bgBlueish);
          color: var(--bgBlueish__text);
          appearance: none;
          border: 3px solid var(--bgBlueish__fadedText);
          font-size: 16px;
          font-weight: 500;
          border-radius: 4px;
          line-height: normal;
        }

        .input:focus {
          outline: none;
          border-color: var(--bgBlueish__tintedText);
        }

        .input--error {
          border-color: red !important;
        }

        .inputCity {
          position: absolute;
          right: 12px;
          bottom: 34px;
          font-size: 14px;
          font-weight: 500;
          color: var(--bgBlueish__text);
          user-select: none;
        }
      `}</style>
    </label>
  );
}
